export enum LinkableItemLifecycleStates {
    SELECTED = 'selected',
    IN_TRANSIT = 'inTransit',
    FINALIZED = 'finalized',
}

export interface StateNode<T> {
    availableLifecycleStates?: T[];
    name: T;
}

export interface LinkableItem {
    arrivalLocation: string;
    linkableItem: string;
    modifyPermanentLocation: boolean;
    state: StateNode<LinkableItemLifecycleStates>;
    linkableItemReferenceType: string;
}

export interface LinkableItemStateResource {
    state: LifecycleStateResource
    linkableItem: LinkableArchiveItemResource
    createdInRecord: boolean
}

export interface LifecycleStateResource {
    name?: String
    availableLifecycleStates?: String[]
}

export interface LinkableItemRef {
    id?: String
    classNameSkin?: String
}

export interface WorkflowSchema<T> {
    currentState: StateNode<T>;
    linkableItems: LinkableItem[];
}

export interface LinkableArchiveItemResource {
    linkableItemReferenceType?: string
    linkableItem?: string
}